import Container from "typedi";

export function useService<T>(clazz: new (...args: any[]) => T){
    return Container.get(clazz)
}